// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const InfoModalLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-InfoDialogContainer" */ "../presentational/infoModal/InfoModal")).then((bundle)=>{
        return {
            default: bundle.InfoModal
        };
    });
export const LazyInfoModal = /*#__PURE__*/ lazy(InfoModalLazyLoader);
